import { Star } from "lucide-react";

/**
 * Call-to-action shown on a business detail page when there are zero reviews.
 *
 * Drives review submission — the primary trust signal of the platform.
 */
export default function FirstReviewCTA({ onClick }) {
  return (
    <div
      data-testid="first-review-cta"
      className="rounded-2xl p-6 md:p-7 text-center"
      style={{
        background: "#FDF6E3",
        border: "2px solid #E8A020",
      }}
    >
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-lokaso-gold/20 text-lokaso-gold mb-3">
        <Star className="w-6 h-6 fill-lokaso-gold" />
      </div>
      <h3 className="font-display text-xl md:text-2xl font-bold text-lokaso-dark">
        Aucun avis pour le moment
      </h3>
      <p className="mt-2 text-stone-700 max-w-md mx-auto">
        Vous connaissez cette entreprise ? Partagez votre expérience et aidez la
        communauté guinéenne à faire de meilleurs choix.
      </p>
      <button
        type="button"
        onClick={onClick}
        data-testid="first-review-cta-btn"
        className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-lokaso-gold text-lokaso-dark font-bold hover:brightness-95 transition"
      >
        <Star className="w-4 h-4" />
        Laisser le premier avis
      </button>
    </div>
  );
}
